module.exports = __webpack_public_path__ + "static/media/flood3.71dedefa.png";